import React from 'react';
import { Route } from 'react-router-dom';
import { FileStoreMain } from '../ui/fileStore/FileStoreMain';

export const fileStoreRoutes = [
    <Route path="/file-store" element={<FileStoreMain />} key="fileStore" />,
];


